declare global {
  interface Window {
    // Wird von scripts/prerender.js gesetzt, während Headless Chrome die Seiten vorrendert
    __PRERENDER__?: boolean;
  }
}

export const isPrerendering = () => window.__PRERENDER__ === true;
